export default __webpack_public_path__ + "static/media/m3.2680f2e3.png";